import React from 'react';
import { useCoverage } from '@components/service-and-repair/components/coverage-screen/use-coverage';
import styles from './benefits-page.module.css';

export const BenefitsPage = () => {
  const { deductible } = useCoverage();

  const { inNetwork = 0, outOfNetwork = 0 } = deductible || {};
  const nothingToShow = !inNetwork && !outOfNetwork;

  return (
    <>
      <div className={styles['heading']}>Benefits of using an in-network shop for your covered repairs</div>
      <div className={styles['deductible']}>
        {!nothingToShow && (
          <div className={styles['amount']}>
            <div className={styles['value']}>${inNetwork}</div>
            <div className={styles['label']}>Deductible</div>
          </div>
        )}

        <ul>
          {nothingToShow && <li>Lower deductible than out-of-network shops</li>}
          <li>12-month / 12,000-mile guarantee</li>
          <li>Waived diagnostic fee</li>
          <li>Easy coordination with SilverRock™ to submit your claim</li>
        </ul>
      </div>
      {outOfNetwork ? (
        <div className={styles['deductible-footer']}>${outOfNetwork} deductible for out-of-network repairs</div>
      ) : null}
    </>
  );
};
